import React from "react";

const Spacer = ({ x, y }) => {
  if (x) return <div style={{height: '100%', width: x}}></div>;
  else return <div style={{height: y, width: '100%'}}></div>;
};

export default Spacer;
